import { useNavigate } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { Button } from '@tempo-io/sui-button';
import { Effectors } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { useOrgName } from '@/lib/hooks/common/useOrgName';

export const VisualizationNoItemsState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const org = useOrgName();

  const noItemsDescription =
    visualizationType === 'swimlane'
      ? t(($) => $.views.swimlane.emptyStates.noItems.description)
      : visualizationType === 'timeline'
        ? t(($) => $.views.timeline.emptyStates.noItems.description)
        : visualizationType === 'table'
          ? t(($) => $.views.table.emptyStates.noItems.description)
          : null;

  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="text-xl font-bold">
        {t(($) => $.views.visualization.emptyStates.noItems.title)}
      </div>
      {noItemsDescription && (
        <div className="mb-2 text-text-neutral-secondary">{noItemsDescription}</div>
      )}
      <Button
        className="my-2 w-60"
        onClick={() => navigate({ to: '/org/$org/settings/work-integrations', params: { org } })}
      >
        <Effectors /> {t(($) => $.itemTable.emptyState.button)}
      </Button>
      <div className="mt-4 text-base">
        {t(($) => $.itemTable.emptyState.help)}{' '}
        <a
          href="https://help.tempo.io"
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-info"
        >
          {t(($) => $.itemTable.emptyState.guide)}
        </a>{' '}
        {t(($) => $.itemTable.emptyState.helpSuffix)}
      </div>
    </div>
  );
};
